import React from 'react';

import { useTranslation } from 'react-i18next';

import { ChevronIcon } from '@icons';

import { Button } from '@shared/components/button';

import { EmptyState } from '@components/empty-state';
import { Loader } from '@components/loader';

import { config } from '@/config.ts';

import * as Styled from './shop-pagination.styled';

type OwnProps = {
	hasItems: boolean;
	hasMore: boolean;
	isLoading: boolean;
	onLoadMore: () => void;
	totalItems?: number;
	displayedItems?: number;
};

const ShopPagination: React.FC<OwnProps> = ({
	hasItems,
	hasMore,
	isLoading,
	onLoadMore,
	totalItems = 0,
	displayedItems = 0
}) => {
	const { t } = useTranslation('main');

	const isNgu3 = config.BRAND === 'ngu3';
	const isCom2 = config.BRAND === 'com2';
	const isRockets = config.BRAND === 'rockets';
	const isNomad = config.BRAND === 'nomad';
	const isBlitz = config.BRAND === 'blitz';
	const sk2 = config.BRAND === 'sk2';

	const isExternalBrand = isNgu3 || isCom2 || isRockets || isNomad || isBlitz || sk2;

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	};

	if (!hasItems && isLoading) {
		return <Loader />;
	}

	if (!hasItems && !isLoading) {
		return (
			<EmptyState
				title={t('nothing_here')}
				description={isExternalBrand ? t('try_another_filters_no_brand') : t('try_another_filters')}
			/>
		);
	}

	if (!hasItems) {
		return null;
	}

	const additionalItemsCount = totalItems - displayedItems;

	return (
		<Styled.PaginationContainer>
			{!isLoading && hasMore && additionalItemsCount > 0 && (
				<Button color='dark' size='large' onClick={onLoadMore} disabled={isLoading}>
					{t('more')}
				</Button>
			)}

			{!isLoading && hasItems && (
				<Styled.ScrollToTopButton onClick={scrollToTop}>
					<ChevronIcon.Up />
				</Styled.ScrollToTopButton>
			)}
		</Styled.PaginationContainer>
	);
};

export default ShopPagination;
